import React, { useState, useEffect } from 'react';

export default function Footer() {
    const [time, setTime] = useState('');
    const [isArabicMode, setIsArabicMode] = useState(false);

    useEffect(() => {
        const updateTime = () => {
            const now = new Date();
            const locale = isArabicMode ? 'ar-EG' : 'fr-FR';
            setTime(now.toLocaleTimeString(locale, {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
            }));
        };

        updateTime();
        const interval = setInterval(updateTime, 1000);
        return () => clearInterval(interval);
    }, [isArabicMode]);

    return (
        <footer className="footer">
            <div className="footer__inner">
                <div className="footer__col">
                    <div className="footer__col-title">© 2026 NA$$</div>
                    <ul>
                        <li><a href="/mentions-legales">Mentions Légales</a></li>
                        <li><a href="/politique-de-confidentialite">Politique de confidentialité</a></li>
                    </ul>
                </div>

                <div className="footer__col">
                    <div
                        className="footer__clock"
                        onClick={() => setIsArabicMode(!isArabicMode)}
                        style={{
                            cursor: 'pointer',
                            fontFamily: isArabicMode ? "'Amiri', serif" : 'inherit'
                        }}
                        title="Changer le fuseau / langue"
                    >
                        {time}
                    </div>
                    <div className="footer__date">PARIS</div>
                </div>

                <div className="footer__col">
                    <div className="footer__col-title">Réseaux sociaux</div>
                    <ul>
                        <li><a href="https://www.instagram.com/n_a_s_s___/" target="_blank" rel="noreferrer">Instagram</a></li>
                        <li><a href="https://www.linkedin.com/in/inès-gharbi-912b26315" target="_blank" rel="noreferrer">LinkedIn (Inès Gharbi)</a></li>
                    </ul>
                </div>

                <div className="footer__col" style={{ textAlign: 'right' }}>
                    <ul>
                        <li><a href="/">Accueil</a></li>
                        <li><a href="/projets">Projets</a></li>
                        <li><a href="/a-propos">À propos</a></li>
                        <li><a href="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>
        </footer >
    );
}
